import callApiAxiosClient from '../../../axios/axios_client';
import { detectionSimpleList } from '../../../models';

async function getDistinctDetectionTypes(): Promise<detectionSimpleList> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;
  return callApiAxiosClient<detectionSimpleList>({
    method: 'get',
    url: 'detections/distinct-detection-types',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
  });
}
export default getDistinctDetectionTypes;
